import { render } from "./MisServicios.vue?vue&type=template&id=2ca0d114&scoped=true"
import script from "./MisServicios.vue?vue&type=script&lang=js"
export * from "./MisServicios.vue?vue&type=script&lang=js"

import "./MisServicios.vue?vue&type=style&index=0&id=2ca0d114&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca0d114"]])

export default __exports__